import React, {useState} from "react";
import {Button, Dialog, Text, Tile} from "@wakelet/ui-kit";
import {translateKey} from "../language/translate";
import {CentralContent} from "../central-content/CentralContent";
import {getAccountApiUrl} from "../../env/env";
import {useAuth} from "../auth/AuthContext";
import {Spinner} from "../loading/Spinner";

const exportURL = getAccountApiUrl("/exports");

export const ExportContent: React.FC = () => {
  const {user} = useAuth();
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportUrl, setExportUrl] = useState("");
  const triggerExport = async () => {
    setExportDialogOpen(true);
    const token = await user?.getIdToken();
    const headers = {Authorization: `Bearer ${token}`};
    await fetch(exportURL, {headers, method: "POST", body: JSON.stringify({type: "portable"})});
    const interval = setInterval(async () => {
      const res = await fetch(exportURL, {headers});
      const {exports} = await res.json() || {};
      if (!exports.length) {
        return;
      }
      const newestExport = exports[exports.length - 1];
      const createdDate = new Date(newestExport.created);
      const now = new Date();
      if (createdDate.getTime() + 600000 > now.getTime()) {
        setExportUrl(newestExport.href);
        clearInterval(interval);
      }
    }, 5000);
  };


  return <Tile>
    <Dialog title={translateKey("settings:manageAccount.downloadYourInformation.inJsonAtAnyTime")}
            open={exportDialogOpen} onClose={() => setExportDialogOpen(false)} data-testid={"export-dialog"}>
      <CentralContent>
        {!exportUrl && <Spinner/>}
        {exportUrl && <Button onClick={() => {
          window.location.href = exportUrl
        }
        } data-testid={"download-btn-in-dialog"}><Button.Label
          text={translateKey("settings:manageAccount.downloadYourInformation.downloadJsonFile")}></Button.Label></Button>}
      </CentralContent>
    </Dialog>
    <Text.Heading level={3}>{translateKey("account:your.data")}</Text.Heading>
    <Text.Paragraph
      className={"mb-1"}>{translateKey("settings:manageAccount.downloadYourInformation.inJsonAtAnyTime")}</Text.Paragraph>
    <div>
      <Button onClick={() => triggerExport()} variant="secondary" className="float-right"
              data-testid={"trigger-export-btn"}>
        <Button.Label text={translateKey("settings:manageAccount.downloadYourInformation.createJsonFile")}/>
      </Button>
    </div>
  </Tile>
}
